import React from "react"
import { Accordion, Button } from "react-bootstrap"
import { makeStyles } from "@material-ui/core"
import { appConfig } from "../config.js"


// const backgroundColor = "#343a40 !important;" // grey
const backgroundColor = appConfig.theme.backgroundColorLighter1

// const separatorColor = "slategrey"
const separatorColor = appConfig.theme.backgroundColorLighter2


const useStyles = makeStyles((theme) => ({
    darkBackground: {
        background: backgroundColor + " !important;",
        color: "white !important;",
        borderRadius: "5px",
        // on hover (but only if not open) we add a hover effect
        "&.collapsed:hover": {
            // boxShadow: "0 0 5px grey",  // for light background
            boxShadow: "0 0 5px white",
        },
        // on focus remove the boxshadow
        "&:focus": {
            // borderColor: "grey",  // for light background
            borderColor: "none",
            boxShadow: "none",
        },
        "&::after": {  // little arrow on the right, let's turn it from blue to white
            filter: "brightness(6)",
        },
        "&:not(.collapsed)::after": {  // little arrow on the right, let's turn it from blue to white
            filter: "grayscale(1) brightness(200%)",
        },
    }
}))


/**
 * 
 * @param {*} props:
 *      - title      string
 *      - pass any children as JSX to display inside the accordion 
 * @returns 
 * 
 */
export default function ClickToOpenCardDark(props) {
    const classes = useStyles()
    return (
        <Accordion bsPrefix={classes.darkBackground}>
            <Accordion.Item eventKey="0" bsPrefix={classes.darkBackground}>

                {/* we take the accordion-button which is great
                    but we override some colors with classes.darkBackground */}
                <Accordion.Button eventKey="0" bsPrefix={"accordion-button " + classes.darkBackground}>
                    {props.title}
                </Accordion.Button>

                <Accordion.Body eventKey="0" style={{
                    background: backgroundColor,
                    color: "white",
                    borderTop: "3px solid " + separatorColor
                }}>
                    {props.children}
                </Accordion.Body>

            </Accordion.Item>
        </Accordion >
    )
}
